import React from "react";
import { JOB_BOARDS, isPostedOnBoard } from "./recruiterConstants";

export default function JobBoardChips({ boardPosts, platforms }) {
  const items = Array.isArray(boardPosts) && boardPosts.length
    ? boardPosts.map((post) => {
      const id = post.id || post.platform;
      const board = JOB_BOARDS.find((b) => b.id === id) || { id, label: id, color: "#64748b" };
      return { ...board, ...post, id, status: post.status, externalUrl: post.externalUrl || post.external_url };
    })
    : (platforms || JOB_BOARDS.map((b) => b.id)).map((id) => {
      const board = JOB_BOARDS.find((b) => b.id === id) || { id, label: id, color: "#64748b" };
      return { ...board, status: "pending" };
    });

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
      {items.map((post) => {
        const color = post.color || JOB_BOARDS.find((b) => b.id === post.id)?.color || "#64748b";
        const onSite = isPostedOnBoard(post);
        const onWibil = !onSite && (post.status === "live" || post.status === "feed_published" || post.status === "posted");
        const failed = post.status === "failed";
        const mark = onSite ? " OK live" : onWibil ? "  ·  Wibil only" : failed ? " !" : "";
        return (
          <span key={post.id} style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 99, background: `${color}18`, color, border: `1px solid ${color}44` }}>
            {post.label || post.id}{mark}
          </span>
        );
      })}
    </div>
  );
}
